import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { SipAccountService } from '@pbx/services/SipAccountService';
import i18n from '@app/plugins/i18n';
import ItemForm from '@pbx/components/sip-accounts/form/modal-sip-edit-form';

class SipAccountModalService extends ModalService {
  constructor() {
    super(SipAccountService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('pbx.sip-account.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }

  edit(item) {
    return this.$open({
      title: i18n.t('shared.component.modal.edit'),
      width: this.size.large,
      loading: true,
      render: h =>
        h(ItemForm, {
          props: {
            id: item.id,
            item: item
          },

          on: {
            success: data => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new SipAccountModalService();
export { instance as SipAccountModalService };
